import { NgModule } from '@angular/core';
import { EmpusaMicroAppType } from '@empusa/empusa-core';
import { PackagingReuseHomeModule } from './packaging-reuse-home.module';

@NgModule({
  declarations: [],
  imports: [],
  exports: []
})
export class PackagingReuseModule { 
  name: string = "packaging-reuse";
  description: string = "Reutilización de envases"
  icon: string = "packaging-reuse";
  page: any = PackagingReuseHomeModule;
  homeApp: boolean = false;
  path: string = "packaging-reuse";
  order: number = 1;
  resourceServerId: string = "keycloak-auth-manager-resources-server";
  appType: EmpusaMicroAppType = EmpusaMicroAppType.home;

  constructor() {
    //we register ourselves
    (<any>window).empusa(this);
    console.debug("Load microapp " + this.name);
  }
}
